document.addEventListener("DOMContentLoaded", function () {
  const lojas = document.querySelectorAll(".lojas .loja");
  const imageContainer = document.querySelector(".lojas .image");
  const mapIframe = document.getElementById("map_canvas");

  if (lojas.length > 0 && window.storeLocations) {
    lojas.forEach((loja, index) => {
      loja.addEventListener("click", (event) => {
        const image = event.target.getAttribute("data-image");

        imageContainer.innerHTML = '<img src="' + image + '">';

        lojas.forEach((loja) => {
          loja.classList.remove("active");
        });

        event.target.classList.add("active");

        // Atualiza o iframe com a localização selecionada
        const location = window.storeLocations[index];
        if (location) {
          const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
            location.address,
          )}&hl=pt-BR&z=15&output=embed`;
          mapIframe.src = mapUrl;
        }

        // Rola a tela até o mapa no mobile com espaçamento de 60px
        if (window.mobile && event.isTrusted) {
          const offset =
            mapIframe.getBoundingClientRect().top + window.pageYOffset - 60;
          window.scrollTo({ top: offset, behavior: "smooth" });
        }
      });
    });

    // Carrega a primeira loja por padrão
    lojas[0].click();

    const firstImage = lojas[0].getAttribute("data-image");
    imageContainer.innerHTML = '<img src="' + firstImage + '">';
  }
});
